// organization.service.ts
import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';

import {Organization} from './organization.model';


// Example response interfaces
export interface FetchOrganizationsResponse {
  data: {
    organizations: Organization[];
  }
}

interface CreateOrganizationResponse {
  data: Organization;
}

interface FetchOrganizationByIdResponse {
  data: Organization;
}

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private apiService: ApiService) {}

  /**
   * Fetches all organizations.
   */
  async fetchAll(): Promise<Organization[]> {
    try {
      // GET /v1/secure/organization
      const response = await this.apiService.get<FetchOrganizationsResponse>('/organization');
      return response.data.organizations;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Creates a new organization.
   */
  async create(organizationData: Organization): Promise<Organization> {
    try {
      // POST /v1/secure/organization
      const response = await this.apiService.post<CreateOrganizationResponse>('/organization', organizationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(organizationData: Organization): Promise<Organization> {
    try {
      // PUT /v1/secure/organization/{uuid}
      const response = await this.apiService.put<CreateOrganizationResponse>(`/organization/${organizationData.id}`, organizationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(organizationId: string): Promise<void> {
    try {
      // DELETE /v1/secure/organization/{uuid}
      await this.apiService.delete(`/organization/${organizationId}`);
    } catch (error) {
      throw error;
    }
  }

  /**
   * Fetches a single organization by its UUID.
   */
  async fetchById(uuid: string): Promise<Organization> {
    try {
      // GET /v1/secure/organization/{uuid}
      const response = await this.apiService.get<FetchOrganizationByIdResponse>(`/organization/${uuid}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
